export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Rated',
        category: ['User', 'Ratings'],
        description: 'When the game was rated.',
        summarise: {
            prefix: 'Played'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    }
}